import { render, staticRenderFns } from "./EditPremadePlan.vue?vue&type=template&id=6a63b9fc"
import script from "./EditPremadePlan.vue?vue&type=script&lang=ts"
export * from "./EditPremadePlan.vue?vue&type=script&lang=ts"
import style0 from "./EditPremadePlan.vue?vue&type=style&index=0&id=6a63b9fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports